import moment from "moment";
import { getWeight, getParcels } from "./routes";
import { isNil } from "lodash";

const allFields = [
  {
    headerName: "Route",
    key: "routeCode",
    source: "route",
  },
  {
    headerName: "Driver Name",
    key: "driverName",
    source: "driver",
    transform: (value) => value || "",
  },
  {
    headerName: "Driver Id",
    key: "userId",
    source: "driver",
    transform: (value) => value || "",
  },
  {
    headerName: "Duty Start Time",
    key: "dutyStartTime",
    source: "driver",
    transform: (value) => value || "00:00",
  },
  {
    headerName: "Duty End Time",
    key: "dutyEndTime",
    source: "driver",
    transform: (value) => value || "00:00",
  },
  {
    headerName: "Depot Depart Time",
    key: "plannedDepartTime",
    source: "driver",
    transform: (value) => value || "00:00",
  },
  {
    headerName: "Depot Return Time",
    key: "plannedReturnTime",
    source: "driver",
    transform: (value) => value || "00:00",
  },
  {
    headerName: "Total Stops",
    key: "stops",
    transform: (stops) => `${stops?.length || 0}`,
    withVolumeDataOnly: true,
    source: "route",
  },
  {
    headerName: "Total Parcels",
    key: "stops",
    transform: (stops) => `${getParcels({ stops })}`,
    withVolumeDataOnly: true,
    source: "route",
  },
  {
    headerName: "Total Collections",
    key: "scheduledCollections",
    transform: (scheduledCollections) => `${scheduledCollections?.length || 0}`,
    withVolumeDataOnly: true,
    source: "route",
  },
  {
    headerName: "Total Miles",
    key: "routeOptimisation",
    transform: (optimisation) => optimisation?.routeMileage || "UNK",
    withVolumeDataOnly: true,
    source: "route",
  },
  {
    headerName: "Opportunity Time",
    key: "routeOptimisation",
    transform: (optimisation) => optimisation?.opportunityTime || "UNK",
    withVolumeDataOnly: true,
    source: "route",
  },
  {
    headerName: "Service Exceptions",
    key: "routeOptimisation",
    transform: (optimisation) => optimisation?.serviceExceptions || "UNK",
    withVolumeDataOnly: true,
    source: "route",
  },
  {
    headerName: "Duty Exceptions",
    key: "routeOptimisation",
    transform: (optimisation) => optimisation?.dutyExceptions || "UNK",
    withVolumeDataOnly: true,
    source: "route",
  },
  {
    headerName: "Vehicle Type",
    key: "vehicleType",
    transform: (value) => value || "",
    source: "driver",
  },
  {
    headerName: "Weight",
    key: "stops",
    transform: (stops) => `${getWeight({ stops })} kg`,
    withVolumeDataOnly: true,
    source: "route",
  },
  {
    headerName: "Forecast Ready Time",
    key: "plannedReadyTime",
    transform: (value) => value?.slice(11, 19) || "",
    source: "route",
  },
];

const toCellString = (value, transform) => {
  if (transform) return transform(value);
  else return `${value || ""}`;
};

const toRowString = (fields, route, drivers) =>
  fields
    .map(({ key, transform, source }) =>
      source === "route"
        ? toCellString(route[key], transform)
        : toCellString((drivers[route.driverCode] || {})[key], transform)
    )
    .join(",");

export const getRoutesExtract = (routes, drivers, hasVolumeData) => {
  if (!routes?.length) return {};
  const extractFields = allFields.filter(
    ({ withVolumeDataOnly }) => !withVolumeDataOnly || hasVolumeData
  );
  const headerRow = extractFields.map(({ headerName }) => headerName).join(",");
  const csv = routes
    .reduce(
      (acc, route) => {
        acc.push(toRowString(extractFields, route, drivers));
        return acc;
      },
      [headerRow]
    )
    .join("\r\n");

  return {
    url: URL.createObjectURL(new Blob([csv])),
    fileName: `${moment().tz("Europe/London").format("YYYY-MM-DD HH-mm")}.csv`,
  };
};

export const getRouteRoadSpeedExtract = (routes, routeConfig) => {
  if (!routes?.length) return {};

  const routeHeaderRow = [
    `Route`,
    "Additional minutes",
    "Use toll",
    "Use ferry",
  ].join(",");

  const getRouteValuesRow = ({
    routeCode,
    additionalMinutes,
    useToll,
    useFerry,
  }) =>
    [
      routeCode,
      additionalMinutes || "00:00",
      useToll ? "Yes" : "No",
      useFerry ? "Yes" : "No",
    ].join(",");

  const roadSpeedsHeaderRow = ["Road", "Urban Speed", "Rural Speed"].join(",");

  const getRoadSpeedsValueRows = ({ route, arr }) =>
    route.roadSpeeds.forEach(({ roadCode, description, urban, rural }) => {
      const urbanSpeed = isNil(urban) ? routeConfig[roadCode].urban : urban;
      const ruralSpeed = isNil(rural) ? routeConfig[roadCode].rural : rural;
      arr.push(
        [description, `${urbanSpeed} MPH`, `${ruralSpeed} MPH`].join(",")
      );
    });

  const csv = [...routes]
    .sort(({ routeCode: routeCodeA }, { routeCode: routeCodeB }) =>
      routeCodeA.localeCompare(routeCodeB)
    )
    .reduce((acc, route) => {
      acc.push(routeHeaderRow);
      acc.push(getRouteValuesRow(route));
      acc.push(roadSpeedsHeaderRow);
      getRoadSpeedsValueRows({ arr: acc, route });
      acc.push("");
      return acc;
    }, [])
    .join("\r\n");

  return {
    url: URL.createObjectURL(new Blob([csv])),
    fileName: `${moment().tz("Europe/London").format("YYYY-MM-DD HH-mm")}.csv`,
  };
};
